__turbopack_context__.v({
  "active": "index-module__Caicaq__active",
  "footer": "index-module__Caicaq__footer",
  "icon": "index-module__Caicaq__icon",
  "label": "index-module__Caicaq__label",
  "nav": "index-module__Caicaq__nav",
  "navItem": "index-module__Caicaq__navItem",
});
